import React, { useEffect, useState } from 'react';
import Icon from '../../common/Icons';

function animateValue(from, to, progress, decimals = 0) {
  const factor = 10 ** decimals;
  const raw = from + (to - from) * progress;
  return decimals > 0 ? Math.round(raw * factor) / factor : Math.round(raw);
}

function formatStatValue(value, decimals = 0) {
  if (decimals > 0) {
    return Number(value || 0).toLocaleString('fr-FR', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals
    });
  }
  return Number(value || 0).toLocaleString('fr-FR');
}

export default function HeadDoctorStatCard({
  title,
  value = 0,
  icon = 'chartBar',
  tone = 'indigo',
  subtitle,
  loading,
  decimals = 0
}) {
  const [displayValue, setDisplayValue] = useState(0);

  useEffect(() => {
    if (loading) return undefined;
    let frame = null;
    const start = performance.now();
    const from = displayValue;
    const duration = 520;
    const target = Number(value || 0);

    const tick = (now) => {
      const elapsed = now - start;
      const progress = Math.min(elapsed / duration, 1);
      setDisplayValue(animateValue(from, target, progress, decimals));
      if (progress < 1) frame = requestAnimationFrame(tick);
    };

    frame = requestAnimationFrame(tick);
    return () => {
      if (frame) cancelAnimationFrame(frame);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, loading, decimals]);

  return (
    <article className={`hd-stat-card hd-stat-card--${tone}`}>
      <div className="hd-stat-card__head">
        <span className="hd-stat-card__title">{title}</span>
        <span className="hd-stat-card__icon" aria-hidden>
          <Icon name={icon} size={18} />
        </span>
      </div>
      <div className="hd-stat-card__value">
        {loading ? '—' : formatStatValue(displayValue, decimals)}
      </div>
      {subtitle && <p className="hd-stat-card__sub mb-0">{subtitle}</p>}
    </article>
  );
}
